import React from "react";
import backgroundImage from "../../Booklet/assets/images/Vector 17.svg";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

interface StatCardProps {
  title: string;
  value: number; // this month total
  subtitle?: string;
  Percentage?: number;
  backgroundColor: string;
  color?: string;
  percentageColor?: string;
  lastMonthTotal?: number;
  times?: number;
}

const GrowthCard: React.FC<StatCardProps> = ({
  title,
  value,
  subtitle,
  color,
  Percentage,
  percentageColor,
  backgroundColor,
  lastMonthTotal,
  times,
}) => {
  const isGrowth = (Percentage ?? 0) >= 0;
  const ArrowIcon = isGrowth ? ArrowDropUpIcon : ArrowDropDownIcon;
  const isTimes = (times ?? 0) > 0;
  const isNegative = (times ?? 0) < 0;
  const GrowthIcon = isTimes
    ? TrendingUpIcon
    : isNegative
    ? TrendingDownIcon
    : null;

  return (
    <div
      style={{
        backgroundColor: backgroundColor || "#f5f5f5",
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
        borderRadius: "12px",
        padding: "16px 20px",
        width: "100%",
        height: "100%",
        minHeight: "120px",
        border: "1px solid #D6E6FB",
        position: "relative",
        overflow: "hidden",
        color: color || "black",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {/* Background Image */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          height: "130%",
          width: "70%",
          zIndex: 0,
        }}
      >
        <img
          src={backgroundImage}
          alt="background"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </div>

      {/* Content */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        {/* Title */}
        <p
          style={{
            fontSize: "15px",
            margin: 0,
            color: color || "black",
            fontWeight: 500,
          }}
        >
          {title}
        </p>

        {/* Comparison Row */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            textAlign: "center",
          }}
        >
          {/* Last Month */}
          <div>
            <h3
              style={{
                margin: 0,
                fontSize: "18px",
                fontWeight: 600,
                color: color || "black",
              }}
            >
              {lastMonthTotal ?? "-"}
            </h3>
            <p style={{ margin: 0, fontSize: "12px", color: "#888" }}>
              Last Month
            </p>
          </div>

          {/* Growth Center */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <p
              style={{
                marginTop: "4px",
                fontSize: "12px",
                color: color || "black",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {times !== undefined && (
                <>
                  {GrowthIcon && (
                    <GrowthIcon
                      sx={{ fontSize: 26, color: percentageColor, mr: 0.5 }}
                    />
                  )}
                  {Math.abs(times).toFixed(2)}×
                </>
              )}
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor:
                  percentageColor || (isGrowth ? "#27AE60" : "#E74C3C"),
                borderRadius: "8px",
                padding: "4px 10px",
                fontSize: "12px",
                fontWeight: 500,
                color: "#fff",
              }}
            >
              <ArrowIcon sx={{ fontSize: 16, color: "#fff", mr: 0.5 }} />
              {Math.abs(Percentage ?? 0).toFixed(2)}%
            </div>
          </div>

          {/* This Month */}
          <div>
            <h3
              style={{
                margin: 0,
                fontSize: "18px",
                fontWeight: 600,
                color: color || "black",
              }}
            >
              {value}
            </h3>
            <p style={{ margin: 0, fontSize: "12px", color: "#888" }}>
              This Month
            </p>
          </div>
        </div>

        {/* Subtitle */}
        {subtitle && (
          <p
            style={{
              fontSize: "12px",
              margin: 0,
              color: color || "black",
            }}
          >
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default GrowthCard;
